import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import { mountDelay, noWidthSpace } from '../../config';

import type { TProgressBar, TStyles } from './models';

export const ProgressBar: FC<TProgressBar> = ({
    antValue = 0,
    className,
    initValue = 0,
    styles,
    theme = 'red',
    value = 0,
}) => {
    const [{ antValueParam, valueParam }, setState] = useState({
        antValueParam: initValue,
        valueParam: initValue,
    });

    const themeTheme = `${theme}Theme` as keyof TStyles;

    // Показать проценты заполнения после таймаута
    useEffect(() => {
        const timer = window.setTimeout(() => {
            setState({
                antValueParam: Math.min(antValue, 100),
                valueParam: Math.min(value, 100),
            });
        }, mountDelay);

        return () => {
            window.clearTimeout(timer);
        };
    }, [antValue, value]);

    return (
        <div className={cn(styles.bg, className)} data-test-id="progress-bar">
            <div
                className={styles.ant}
                data-test-id="progress-bar-ant-line"
                style={{ width: `${antValueParam}%` }}
            >
                {noWidthSpace}
            </div>
            <div
                className={cn(styles[themeTheme])}
                data-test-id="progress-bar-filled-line"
                style={{ width: `${valueParam}%` }}
            >
                {noWidthSpace}
            </div>
        </div>
    );
};
